import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate } from 'react-router-dom';

function ErrorFallback({ error }) {
  console.error('Caught by ErrorBoundary:', error);
  return <Navigate to="/error" replace />;
}

export default function ErrorBoundaryFunc({ children }) {
  useEffect(() => {
    const origOnError = window.onerror;
    const origOnRejection = window.onunhandledrejection;

    window.onerror = () => true;
    window.onunhandledrejection = (event) => {
      event.preventDefault();
      return true;
    };

    return () => {
      window.onerror = origOnError;
      window.onunhandledrejection = origOnRejection;
    };
  }, []);

  return (
    <ErrorBoundary
      fallbackRender={ErrorFallback}
      onError={(error, info) => {
        console.error('ErrorBoundary onError:', error, info);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
